import { useState, useEffect } from "react";
import "../assets/css/Contact.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

import { Helmet } from "react-helmet";
import data from "../../src/component/ApiUrl/meta_api";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";

const contact = [
  {
    icon: <FaPhoneAlt />,
    label: "Phone",
    val: "(+91) 8428010909",
    sub: "(+91) 8428330909",
    btn: "Call Now",
    link: "tel:+918428010909",
  },
  {
    icon: <FaEnvelope />,
    label: "Email",
    val: "Support@skimitarhindusthan.com",
    sub: "",
    btn: "Send Email",
    link: "mailto:Support@skimitarhindusthan.com",
  },
  {
    icon: <FaMapMarkerAlt />,
    label: "Address",
    val: "1st Floor, D.No:027,Ward 25th, 2nd Cross, Annamalai Layout, Nalli Hospital Road, Erode -638011",
    sub: "",
    btn: "View Map",
    link: "https://www.google.com/maps/place/11%C2%B020'45.9%22N+77%C2%B042'58.7%22E/@11.346076,77.7137226,750m/data=!3m2!1e3!4b1!4m4!3m3!8m2!3d11.346076!4d77.7162975?hl=en&entry=ttu&g_ep=EgoyMDI2MDQwMS4wIKXMDSoASAFQAw%3D%3D",
  },
];

const faqs = [
  {
    q: "How quickly will I receive a response after submitting the form?",
    a: "Our team typically responds within 24 business hours. For urgent matters, call us at (+91) 8428010909 or (+91) 8428330909 during business hours.",
  },
  {
    q: "Do you offer online training programs?",
    a: "Yes! All our training programs are available in both online and classroom formats. You can attend live online sessions from anywhere in India or join our in-person batches at our Erode training centre.",
  },
  {
    q: "Can you deliver services and training outside Erode?",
    a: "Absolutely. We provide pan-India service delivery and on-site corporate training across all major states including Tamil Nadu, Karnataka, Andhra Pradesh, Maharashtra, Kerala and more.",
  },
  {
    q: "Do you provide placement assistance after course completion?",
    a: "Yes, we offer dedicated placement support including resume building, mock interview sessions, career counselling, and direct job referrals to our industry partner network.",
  },
  {
    q: "How can I enroll in a corporate training program for my team?",
    a: "Fill out the contact or quote form above and select 'Corporate Training'. Our training team will reach out to understand your team's needs and design a customized program for you.",
  },
  {
    q: "What is the office address of Skimitar Hindusthan?",
    a: "We are located at: 1st Floor, D.No: 027, Ward 25th, 2nd Cross, Annamalai Layout, Nalli Hospital Road, Erode – 638011, Tamil Nadu, India.",
  },
];

// Title
function SectionLabel({ text }) {
  return (
    <p
      className="fw-semibold text-uppercase mb-1"
      style={{ fontSize: 20, color: "#cc0000", letterSpacing: 1 }}
    >
      {text}
    </p>
  );
}

export default function Contact() {
  const [meta, setMeta] = useState(null);

  // scroll top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const fetchData = () => {
    const ContactMeta = data[0]?.contact_page;
    if (ContactMeta) {
      setMeta(ContactMeta);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 700, once: true });
  }, []);

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Contact Us"}</title>
      </Helmet>

      {/* Hero */}
      <div
        className="text-center mb-4 d-flex flex-column justify-content-center align-items-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 0, 0, 0.86), rgba(0, 0, 0, 0.86)), url(" +
            require("../assets/img/Contact/banner.jpg") +
            ")",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "60vh",
        }}
      >
        <span
          className="badge mb-3 px-3 py-2"
          style={{
            background: "#cc0000",
            fontSize: "1rem",
            letterSpacing: "0.5px",
          }}
          data-aos="fade-down"
          data-aos-duration="600"
        >
          Contact Us
        </span>

        <h1
          className="text-white fw-medium mb-3"
          style={{ fontSize: "clamp(20px,4vw,28px)" }}
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-duration="700"
        >
          Let's Start a <span className="text-red">Conversation</span>
        </h1>

        <p
          className="mx-auto mb-0 content-text text-light"
          style={{
            maxWidth: "520px",
          }}
          data-aos="fade-up"
          data-aos-delay="250"
          data-aos-duration="700"
        >
          Whether you're looking for a technology solution, training program, or
          more, we're here to help. Reach us anytime.
        </p>
      </div>

      {/* Info Strip */}
      <div className="container container_width mt-5">
        <div className="row g-4 justify-content-center align-items-stretch">
          {contact.map((data, i) => (
            <div
              key={i}
              className={`col-12 col-sm-6 col-lg-4 d-flex ${i >= 2 ? "mt-md-2" : ""}`}
              data-aos="fade-up"
              data-aos-delay={i * 350}
              data-aos-duration="700"
            >
              <div className="h-100 w-100 text-center d-flex flex-column">
                {/* Icon */}
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                  style={{
                    width: "70px",
                    height: "70px",
                    background: "linear-gradient(135deg,#cc0000,#e63939)",
                    fontSize: "28px",
                    color: "#fff",
                  }}
                >
                  {data.icon}
                </div>

                {/* Title */}
                <h5
                  className="fw-bold text-dark mb-2"
                  style={{ fontSize: "20px" }}
                >
                  {data.label}
                </h5>

                {/* Content */}
                <div className="flex-grow-1">
                  <p className="content_text text-center mb-1">{data.val}</p>

                  {data.sub && (
                    <p className="mb-0 text-center content_text">{data.sub}</p>
                  )}
                </div>

                {/* Button */}
                <div className="mt-3">
                  <a
                    href={data.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-danger rounded-pill w-50"
                    style={{
                      borderWidth: "1.5px",
                      fontSize: "14px",
                      padding: "8px 0",
                    }}
                  >
                    {data.btn}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Form + Right */}
      <div className="margin_top bg_color py-5">
        <div className="container container_width">
          <div data-aos="fade-right" data-aos-duration="600">
            <SectionLabel text="Get In Touch" />
          </div>

          <h2
            className="fw-semibold mb-3"
            style={{ fontSize: 20 }}
            data-aos="fade-right"
            data-aos-delay="100"
            data-aos-duration="600"
          >
            We'd Love to Hear From You
          </h2>

          <p
            className="mb-4 content_text"
            data-aos="fade-right"
            data-aos-delay="150"
            data-aos-duration="600"
          >
            Fill in the form below or reach us directly our team will get back
            to you within 24 hours.
          </p>

          <div className="container container_width mt-5">
            <div className="row g-4">
              {/* LEFT SIDE */}
              <div className="col-12 col-lg-6 d-flex flex-column gap-4">
                {/* MAP */}
                <div
                  className="card border overflow-hidden p-2"
                  data-aos="zoom-in"
                  data-aos-duration="800"
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!4v1775735699564!6m8!1m7!1scJG6v5mAHPATHV8XddFKxA!2m2!1d11.34620705582019!2d77.71658219496483!3f304.52!4f-13.549999999999997!5f0.4528893779179686"
                    width="600"
                    height="450"
                    style={{ border: "0" }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                {/* BUSINESS HOURS */}
                <div
                  className="card border p-3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="700"
                >
                  <p className="fw-medium mb-3" style={{ fontSize: "12px" }}>
                    🕐 Business Hours
                  </p>

                  {[
                    {
                      day: "Monday – Friday",
                      time: "9:00 AM – 8:00 PM",
                      closed: false,
                    },
                    {
                      day: "Saturday",
                      time: "9:00 AM – 8:00 PM",
                      closed: false,
                    },
                    { day: "Sunday", time: "9:00 AM – 6:00 PM", closed: true },
                  ].map(({ day, time, closed }) => (
                    <div
                      key={day}
                      className="d-flex justify-content-between align-items-center border-bottom py-2"
                      style={{ fontSize: "12px" }}
                    >
                      <span className="text-secondary">{day}</span>

                      <span
                        className="fw-medium"
                        style={closed ? { color: "#E24B4A" } : {}}
                      >
                        {time}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT SIDE FORM */}
              <div
                className="col-12 col-lg-6"
                data-aos="zoom-in"
                data-aos-delay="100"
                data-aos-duration="800"
              >
                <div className="card shadow p-4 h-100">
                  <p
                    className="fw-medium border-bottom pb-3 mb-3"
                    style={{ fontSize: "14px" }}
                  >
                    ✉️ Send Us a Message
                  </p>

                  <div className="row g-3 mb-3">
                    <div className="col-12 col-sm-6">
                      <label
                        className="form-label fw-medium"
                        style={{ fontSize: "11px" }}
                      >
                        Full Name *
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Your full name"
                        style={{ fontSize: "12px" }}
                      />
                    </div>

                    <div className="col-12 col-sm-6">
                      <label
                        className="form-label fw-medium"
                        style={{ fontSize: "11px" }}
                      >
                        Phone Number *
                      </label>

                      <input
                        type="tel"
                        className="form-control"
                        placeholder="+91 XXXXX XXXXX"
                        style={{ fontSize: "12px" }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label
                      className="form-label fw-medium"
                      style={{ fontSize: "11px" }}
                    >
                      Email Address *
                    </label>

                    <input
                      type="email"
                      className="form-control"
                      placeholder="your@email.com"
                      style={{ fontSize: "12px" }}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      className="form-label fw-medium"
                      style={{ fontSize: "11px" }}
                    >
                      I'm Interested In
                    </label>

                    <select
                      className="form-select"
                      style={{ fontSize: "12px" }}
                    >
                      <option value="">Select an option</option>
                      <option value="Industrial Automation Services">
                        Industrial Automation Services
                      </option>
                      <option value="Embedded Systems & IIoT">
                        Embedded Systems & IIoT
                      </option>
                      <option value="IT & Software Development">
                        IT & Software Development
                      </option>
                      <option value="Digital Marketing Services">
                        Digital Marketing Services
                      </option>
                      <option value="Certification Courses">
                        Certification Courses
                      </option>
                      <option value="Internship Program">
                        Internship Program
                      </option>
                      <option value="Corporate Training">
                        Corporate Training
                      </option>
                      <option value="Seminar & Workshop">
                        Seminar & Workshop
                      </option>
                      <option value="Live Project Work">
                        Live Project Work
                      </option>
                      <option value="General Enquiry">General Enquiry</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label
                      className="form-label fw-medium"
                      style={{ fontSize: "11px" }}
                    >
                      Your Message
                    </label>

                    <textarea
                      className="form-control"
                      rows={5}
                      placeholder="Tell us more about your requirement..."
                      style={{ fontSize: "12px" }}
                    />
                  </div>

                  <button
                    className="btn w-100 text-white mt-2 fw-medium"
                    style={{ background: "#cc0000", fontSize: "13px" }}
                  >
                    Send Message →
                  </button>

                  <p
                    className="text-center text-muted mt-2 mb-0"
                    style={{ fontSize: "10px" }}
                  >
                    We respect your privacy. Your information will never be
                    shared.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="container container_width margin_top">
        <div className="row align-items-center justify-content-center g-4 mb-5">
          {/* LEFT SIDE FAQ */}
          <div className="col-12 col-lg-7">
            <div data-aos="fade-right" data-aos-duration="600">
              <SectionLabel text="Faq" />
            </div>

            <h2
              className="fw-semibold mb-4"
              style={{ fontSize: "20px" }}
              data-aos="fade-right"
              data-aos-delay="100"
              data-aos-duration="600"
            >
              Frequently Asked Questions
            </h2>

            <div className="accordion" id="faqAccordion">
              {faqs.map((faq, i) => (
                <div
                  className="accordion-item"
                  key={i}
                  data-aos="fade-right"
                  data-aos-delay={i * 350}
                  data-aos-duration="600"
                >
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${i !== 0 ? "collapsed" : ""} content_text`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#faq${i}`}
                      aria-expanded={i === 0 ? "true" : "false"}
                      aria-controls={`faq${i}`}
                      style={{
                        fontWeight: "600",
                        color: i === 0 ? "#fff" : "#000",
                        backgroundColor: i === 0 ? "#cc0000" : "#fff",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#cc0000";
                        e.target.style.color = "#fff";
                      }}
                      onMouseLeave={(e) => {
                        if (e.target.classList.contains("collapsed")) {
                          e.target.style.backgroundColor = "#fff";
                          e.target.style.color = "#000";
                        }
                      }}
                    >
                      {faq.q}
                    </button>
                  </h2>

                  <div
                    id={`faq${i}`}
                    className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body"
                      style={{ fontSize: "13px", lineHeight: "1.7" }}
                    >
                      {faq.a}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE IMAGE */}
          <div
            className="col-12 col-lg-5 text-center"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="800"
          >
            <img
              src={require("../assets/img/Contact/contact-1.jpg")}
              alt="FAQ"
              className="img-fluid rounded"
            />
          </div>
        </div>
      </div>
    </>
  );
}
